import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import drives from '../data/drives';
import useFetch from '../hooks/useFetch';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import IconSprite from './IconSprite';
import Map from './Map';
import MapUI from './MapUI';
import TabFocus from './TabFocus';
export function latitudeSort(posts) {
    const sorted = posts.slice();
    sorted.sort((a, b) => Math.sign(b.lnglat[1] - a.lnglat[1]));
    return sorted;
}
const ExplorerMap = () => {
    const { ref, map, loaded: mapLoaded } = useMap('mapbox://styles/romeodigital/cl3l8jyjv000f14qjk403n7wm?optimize=true');
    const { height } = useWindowSize();
    const [routes, setRoutes] = useState(null);
    // Fetch map data from API
    const params = {
        nonce: window.mainSiteData.nonce
    };
    const { data, error } = useFetch(`${window.mainSiteData.root}scenic-rim/v2/explorer-map?${new URLSearchParams(params)}`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        },
    });
    // Handle map data
    useEffect(() => {
        if (error || !data || !data.routes)
            return;
        setRoutes([
            {
                path: 'places',
                meta: {
                    title: 'Places to visit',
                    variant: 'blue',
                    layer: {
                        ...data.routes.places,
                        posts: latitudeSort(data.routes.places.posts),
                    },
                },
            },
            {
                path: 'things',
                meta: {
                    title: 'Things to do',
                    variant: 'red',
                    layer: {
                        ...data.routes.things,
                        posts: latitudeSort(data.routes.things.posts),
                    },
                },
            },
            {
                path: 'wonders',
                meta: {
                    title: 'Natural wonders',
                    variant: 'green',
                    layer: {
                        ...data.routes.wonders,
                        posts: latitudeSort(data.routes.wonders.posts),
                    },
                },
            },
            {
                path: 'drives',
                meta: {
                    title: 'Drive times',
                    variant: 'gold',
                    layer: drives,
                },
            },
        ]);
    }, [data, error, setRoutes]);
    return (_jsxs(TabFocus, { children: [_jsx(IconSprite, {}), _jsxs("div", { className: "w-full", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && routes && _jsx(MapUI, { map: map, routes: routes, includeMajorCities: true })] })] }));
};
export default ExplorerMap;
